import { render, staticRenderFns } from "./LootboxSelection.vue?vue&type=template&id=2c9f60d3&"
import script from "./LootboxSelection.vue?vue&type=script&lang=js&"
export * from "./LootboxSelection.vue?vue&type=script&lang=js&"
import style0 from "./LootboxSelection.vue?vue&type=style&index=0&id=2c9f60d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports